module.exports = __webpack_public_path__ + "img/404.64782bfd.png";